import React, { useState, useEffect } from "react";
import DashboardNav from "../../DashboardNav/DashboardNav";
import DashboardSidebar from "../../DashboardSidebar/DashboardSidebar";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import AddActivationSteps from "./AddActivationSteps";

const MainPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 991);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 991 && isSidebarOpen) {
        setIsSidebarOpen(false);
      } else if (window.innerWidth >= 991 && !isSidebarOpen) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isSidebarOpen]);

  return (
    <>
      <DashboardSidebar isOpen={isSidebarOpen} />
      <DashboardNav
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
      <div className="dashboard-layout">
        <div
          className={`main-section ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="main-dashboard-page-content">
            <Breadcrumbs
              items={[
                { label: "Activation Steps", href: "/activation-steps" },
                { label: "Add Activation Step" },
              ]}
            />
            <div className="row gap-4">
              <div className="col-12">
                <AddActivationSteps />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainPage;
